import clsx from 'clsx'
import { useAtom } from 'jotai'

import { awardsFilesAtom } from 'atoms/awardsFiles.atom'
import { FiltersIndex } from 'components/filters/FiltersIndex'
import { Header } from 'components/header/Header'
import { IndexHeader } from 'components/header/IndexHeader'
import { Footer } from 'Footer/Footer'

import styles from '../components/header/Header.module.scss'

export interface DefaultLayoutProps {
  children?: React.ReactNode
  isIndex?: boolean
}

export const DefaultLayout = (props: DefaultLayoutProps) => {
  const { children, isIndex = false } = props
  const [awardsAtom] = useAtom(awardsFilesAtom)
  return (
    <div className="">
      {isIndex ? <IndexHeader /> : <Header />}
      <div className={clsx('bg-[#F4F4F4]', styles.stickyContent)}>
        <div className={clsx('flex justify-between max-w-[1152px] mx-auto')}>
          <div className="flex justify-between w-full items-center">
            <FiltersIndex />
            <p className="font-bold text-[#866431] pt-2 font-TCCC">RESULTS: {awardsAtom.length}</p>
          </div>
        </div>
      </div>
      <div className="main bg-[#F4F4F4] px-16 mx-auto max-w-[1280px]">{children}</div>
      <Footer className="mt-[96px]" />
    </div>
  )
}
